import produce from "immer";
import React, { FC, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { startRemoveByFormIdRedux } from "../../actions/dustbinAction";
import { startEditModal } from "../../actions/modalAction";
import { cssStyle } from "../../models/cssStyleModel";
import { ModalAttributeModel } from "../../models/modalAttributeModel";
import { AppState } from "../../reducers/rootReducer";
import { getAllRows } from "../../selectors/rowListSelector";
import formService from "../../services/formService";
import RowElement from "../elementComponents/RowElement";

export interface ModalComponentProps {
  isShow: boolean;
  properties: ModalAttributeModel;
  formId: String;
}

const ModalComponent: FC<ModalComponentProps> = ({ isShow, properties, formId }) => {
  const dispatch = useDispatch();
  const modalState = useSelector((state: AppState) => state.modal);
  const rowState = useSelector(getAllRows);
  const sessionState = useSelector((state: AppState) => state.session);
  const formState = useSelector((state: AppState) => state.formList);


  useEffect(() => {
    const getModal = async () => {
      const { data } = await formService.getFormItemById({
        id: formId,
      });
      const newModalState = produce(modalState, (draft) => {
        draft.cssStyles = data.data.form?.cssStyles;
      });
      dispatch(startEditModal(newModalState));
    }

    getModal();

  }, [formId])


  const renderRowList = () => {
    let rowListBySelectedFrom = rowState.filter((row) => { if (row.type === 'form' && row.formId === formId) return row });
    return rowListBySelectedFrom.map((row, i) => {
      return <RowElement row={row} index={i} isPreview={true} />;
    });
  };

  const form = formState.filter((form) => { return form.id === sessionState.selectedFormId })[0];
  const styleObj: { [key: string]: any } = {};
  if (modalState.cssStyles) {
    for (let index = 0; index < modalState.cssStyles.length; index++) {
      styleObj[modalState.cssStyles[index].retrivedStyle] = modalState.cssStyles[index].value;
    }
  }
  // custome css - end

  const modalClose = () => {
    dispatch(startRemoveByFormIdRedux(formId));
    const newModalState = produce(modalState, (draft) => {
      draft.show = false;
    });
    dispatch(startEditModal(newModalState));
  }

  return (
    <Modal
      size={properties?.modalLarge ? 'lg' : 'sm'}
      centered={properties?.modelCentered}
      isOpen={isShow}
      show={isShow}
      onHide={() => {
        modalClose()
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ marginBottom:0 , marginTop:0}}>
          {properties?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{...styleObj}}>
          {renderRowList()}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
